import { graphql, useStaticQuery } from 'gatsby';
import React, { PropsWithChildren } from 'react';
import CookiePopup from '../organisms/CookiePopup';
import Footer from '../organisms/Footer';
import Header from '../organisms/Header';

const Layout = ({ children }: PropsWithChildren<unknown>) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

  return (
    <>
      <div className="fixed z-50 top-2 left-2">
        <a
          href="#main"
          type="button"
          className="px-3 py-2 font-medium bg-white rounded-sm sr-only text-primary focus:not-sr-only u-ring"
        >
          Skip to content
        </a>
      </div>

      <Header />
      <main id="main" className="relative pt-16 md:pt-20">
        {children}
      </main>
      <Footer />

      <CookiePopup />
    </>
  );
};

export default Layout;
